/* BACKEND ACTIONS * */
// eslint-disable-next-line import/prefer-default-export
export const LOGIN = "LOGIN";
export const SET_SESSION = "SET_SESSION";
export const SET_MEDICINE_REQUEST_STATUS = "SET_MEDICINE_REQUEST_STATUS";
export const SET_MEDICINES = "SET_MEDICINES";
export const SET_MEDICINE = "SET_MEDICINE";
export const SET_BRANDS = "SET_BRANDS";
